// tslint:disable
export var OrderingSystemCode;
(function (OrderingSystemCode) {
    // Torro
    OrderingSystemCode[OrderingSystemCode["Torro"] = 1] = "Torro";
    // Campaign
    OrderingSystemCode[OrderingSystemCode["Campaign"] = 2] = "Campaign";
})(OrderingSystemCode || (OrderingSystemCode = {}));
OrderingSystemCode['TORRO'] = 1;
OrderingSystemCode['CAMPAIGN'] = 2;
//# sourceMappingURL=OrderingSystemCode.js.map